module.exports = __webpack_public_path__ + "img/39600.b700269a.jpg";